import ExpertDropdown from "./ExpertDropdown";
import FileNavigatorButton from "./FileNavigatorButton";
import LanguageSwitcher from "./LanguageSwitcher";
import PreviewSiteButton from "./PreviewSiteButton";
import PublishedSiteButton from "./PublishedSiteButton";
import ThemeButton from "./ThemeButton";
import UserDropDown from "./UserDropDown"

const ToolBarRightContainer = () => {
    
    return (
        <div>
            <ul className="list-unstyled">
                <li><PreviewSiteButton/></li>
                <li><PublishedSiteButton/></li>
                <li><ExpertDropdown/></li> 
                <li><FileNavigatorButton/></li>
                <li><LanguageSwitcher/></li>
                <li><UserDropDown/></li> 
            </ul>
        </div>
    )
}

export default ToolBarRightContainer; 